import("../../../../Social-Sorbet/assets/js/splide.js")
	.then(({ Splide }) => {
		const sliders = document.querySelectorAll(".content-single-practice__photos .splide")

		for (let i = 0; i < sliders.length; i++) {
			const trackEl = sliders[i].querySelector(".splide__track")
			const trackId = "splide-track-" + i
			if (trackEl) trackEl.setAttribute("id", trackId)

			const splide = new Splide(sliders[i], {
				type: "slide",
				arrows: false,
				pagination: false,
				padding: "5rem",
				gap: "1.5rem",
				perPage: 3,
				breakpoints: {
                    1280: {
                        perPage: 3,
                        padding: "2rem"
                    },
					992: {
						perPage: 2,
                        padding: "1.25rem"
					},
                    767: {
						perPage: 1,
                        padding: "1.25rem"
					},
				}
			}).mount()

			const container = document.querySelector(".arrow_container")
			const prevBtn = container && container.querySelector(".splide__arrow--prev")
			const nextBtn = container && container.querySelector(".splide__arrow--next")

			if (prevBtn) {
				prevBtn.setAttribute("aria-controls", trackId)
				prevBtn.addEventListener("click", () => splide.go("<"))
			}
			if (nextBtn) {
				nextBtn.setAttribute("aria-controls", trackId)
				nextBtn.addEventListener("click", () => splide.go(">"))
			}

			function updateArrowStates() {
				if (!prevBtn || !nextBtn) return
				const end = splide.Components.Controller.getEnd()
				prevBtn.setAttribute("aria-disabled", splide.index === 0 ? "true" : "false")
				nextBtn.setAttribute("aria-disabled", splide.index >= end ? "true" : "false")
			}

			updateArrowStates()
			splide.on("moved", updateArrowStates)
		}

		initLightbox()
	})
	.catch((err) => {
		console.error(err)
	})

function initLightbox() {
	const lightbox = document.getElementById("practice-lightbox")
	if (!lightbox) return

	const lightboxImg = lightbox.querySelector(".practice-lightbox__img")
	const lightboxClose = lightbox.querySelector(".practice-lightbox__close")
	const lightboxPrev = lightbox.querySelector(".practice-lightbox__prev")
	const lightboxNext = lightbox.querySelector(".practice-lightbox__next")
	const lightboxBackdrop = lightbox.querySelector(".practice-lightbox__backdrop")
	const lightboxCounter = lightbox.querySelector(".practice-lightbox__counter")

	// Gather images from all slides (skip Splide clones if any)
	const slides = Array.from(
		document.querySelectorAll(".content-single-practice__photos .splide__slide[data-lightbox-src]")
	).filter(slide => !slide.classList.contains("splide__slide--clone"))

	const images = slides.map(slide => ({
		src: slide.dataset.lightboxSrc,
		alt: slide.dataset.lightboxAlt || "",
	}))

	let currentIndex = 0
	let previouslyFocused = null

	function updateImage() {
		if (!lightboxImg || !images[currentIndex]) return
		lightboxImg.src = images[currentIndex].src
		lightboxImg.alt = images[currentIndex].alt
		if (lightboxPrev) lightboxPrev.setAttribute("aria-disabled", currentIndex === 0 ? "true" : "false")
		if (lightboxNext) lightboxNext.setAttribute("aria-disabled", currentIndex >= images.length - 1 ? "true" : "false")
		if (lightboxCounter && images.length > 1) lightboxCounter.textContent = `${currentIndex + 1} / ${images.length}`
	}

	function openLightbox(index) {
		currentIndex = index
		updateImage()
		lightbox.removeAttribute("hidden")
		document.body.style.overflow = "hidden"
		previouslyFocused = document.activeElement
		requestAnimationFrame(() => lightboxClose && lightboxClose.focus())
	}

	function closeLightbox() {
		lightbox.setAttribute("hidden", "")
		document.body.style.overflow = ""
		previouslyFocused && previouslyFocused.focus()
	}

	// Attach click handlers to trigger buttons
	slides.forEach((slide, idx) => {
		const trigger = slide.querySelector(".practice-lightbox-trigger")
		if (trigger) trigger.addEventListener("click", () => openLightbox(idx))
	})

	lightboxClose && lightboxClose.addEventListener("click", closeLightbox)
	lightboxBackdrop && lightboxBackdrop.addEventListener("click", closeLightbox)

	lightboxPrev && lightboxPrev.addEventListener("click", () => {
		if (currentIndex > 0) { currentIndex--; updateImage() }
	})
	lightboxNext && lightboxNext.addEventListener("click", () => {
		if (currentIndex < images.length - 1) { currentIndex++; updateImage() }
	})

	// Keyboard: Escape and arrow navigation
	document.addEventListener("keydown", e => {
		if (lightbox.hasAttribute("hidden")) return
		if (e.key === "Escape") { closeLightbox(); return }
		if (e.key === "ArrowLeft" && currentIndex > 0) { currentIndex--; updateImage() }
		if (e.key === "ArrowRight" && currentIndex < images.length - 1) { currentIndex++; updateImage() }
	})

	// Focus trap
	lightbox.addEventListener("keydown", e => {
		if (e.key !== "Tab") return
		const focusable = Array.from(lightbox.querySelectorAll("button")).filter(
			el => !el.hasAttribute("disabled") && el.getAttribute("aria-disabled") !== "true"
		)
		if (!focusable.length) return
		const first = focusable[0]
		const last = focusable[focusable.length - 1]
		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault()
			last.focus()
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault()
			first.focus()
		}
	})
}
